/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const restartAfterSlip = useStore((state) => state.restartAfterSlip);
  const setRestartAfterSlip = useStore((state) => state.setRestartAfterSlip);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.restartAfterSlip.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={restartAfterSlip}
          onChange={(value) => {
            setRestartAfterSlip(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'restart-after-slip',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'skipMeals'}>
            <span>⚖️</span> {t('onboarding.restartAfterSlip.options.skipMeals')}
          </Option>
          <Option value={'cutBadFoods'}>
            <span>🚫</span> {t('onboarding.restartAfterSlip.options.cutBadFoods')}
          </Option>
          <Option value={'startMonday'}>
            <span>💭</span> {t('onboarding.restartAfterSlip.options.startMonday')}
          </Option>
          <Option value={'backCalmly'}>
            <span>🧘</span> {t('onboarding.restartAfterSlip.options.backCalmly')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
